import React from 'react'
import PropTypes from 'prop-types'
import {
  FormGroup,
  ControlLabel,
  HelpBlock,
  FormControl,
  InputGroup,
  Alert
} from 'react-bootstrap'
import { find, prop, equals } from 'ramda';
import questionTypes from '../questionTypes.json'
import unitOfMeasure from '../common/unitOfMeasure'
import { formatNumber } from '../formatNumber'

NumberQuestion.propTypes = {
  questionId: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
  unit: PropTypes.string,
  help: PropTypes.string,
  options: PropTypes.array.isRequired,
  answers: PropTypes.array,
  onAnswer: PropTypes.func,
  readOnly: PropTypes.bool,
  showValidation: PropTypes.bool,
  validationState: PropTypes.string
};

const getAnswerId = prop("answerId");
const findAnswerForOption = option =>
  find(answer => equals(getAnswerId(option), getAnswerId(answer)));

function displayValue(readOnly, answer) {
  if (readOnly && !answer.meta) {
    return answer.meta.displayValue.text || answer.meta.displayValue
  }
  return answer.value || ''
}

function getUnitOfMeasure(answer, measurementUnit, readOnly) {
  if (answer.meta) {
    return readOnly ? answer.meta.unitOfMeasure.unitOfMeasure : measurementUnit.unitOfMeasure;
  }
  return measurementUnit.unitOfMeasure || ''
}

function NumberQuestion({
  questionId,
  text,
  help,
  unit,
  options,
  answers,
  onAnswer,
  readOnly,
  showValidation,
  validationState = null
}) {
  let answer;
  let option;
  if (answers.length === 1) {
    answer = answers[0];
    options.forEach(currentOption => {
      if (currentOption.answerId === answer.answerId) {
        option = currentOption;
      }
    })
  } else {
    option = options[0];
    answer = findAnswerForOption(option)(answers);
  }

  const value = answer ? prop("value")(answer) : '';
  let measurementUnit = unit || unitOfMeasure(option);
  if (typeof(measurementUnit) === 'string') {
    measurementUnit = {
      unitOfMeasure: measurementUnit
    }
  }

  if (measurementUnit && measurementUnit.unitOfMeasure !== 'other') {
    return <FormGroup className='col-md-3 input-form-group' controlId={questionId} validationState={validationState}>
      <ControlLabel>{text}</ControlLabel>
      <InputGroup>
        <FormControl
          type={readOnly? 'text' : 'number'}
          onChange={(event) => onAnswer(questionId, questionTypes.number, option.answerId, event.target.value,
            {
              displayValue: { text: event.target.value },
              unitOfMeasure: measurementUnit
            })}
          disabled={readOnly}
          placeholder={option.text}
          value={formatNumber(displayValue(readOnly, answer))} />
        <InputGroup.Addon>{getUnitOfMeasure(answer, measurementUnit, readOnly)}</InputGroup.Addon>
      </InputGroup>
      {help && <HelpBlock>{help}</HelpBlock>}
    </FormGroup>
  }

  return <FormGroup className='col-md-3 input-form-group' controlId={questionId} validationState>
    <ControlLabel>{text}</ControlLabel>
    <FormControl
      type='number'
      disabled={readOnly}
      placeholder={option.text}
      value={formatNumber(value, false)}
      onChange={(event) => onAnswer(questionId, questionTypes.number, option.answerId, event.target.value,
        {
          displayValue: { text: event.target.value }
        })}/>
    {help && showValidation && <HelpBlock>
      <Alert bsStyle='danger'>
        {help}
      </Alert>
    </HelpBlock>}
  </FormGroup>
}

export default NumberQuestion;



// WEBPACK FOOTER //
// ./src/components/questions/NumberQuestion/NumberQuestion.js